@if (searchQuery) {
  <div class="text-center p-20">
    <span class="text-center">{{ "sphere.searching_for" | translate }}: {{ searchQuery }}&nbsp;&nbsp;&nbsp;</span>
    @if (searching) {
      <fa-icon icon="spinner" [animation]="'spin'" class="m-r-10"></fa-icon>
    }
    <button class="btn btn-secondary btn-sm" (click)="clearSearchQuery.next(true)">Clear</button>
  </div>
}

@if (exchangeService.selectedAttributeFilter) {
  <div class="text-center">
    <span class="text-center">{{ "sphere.showing_that_include" | translate }} {{ exchangeService.selectedAttributeFilter }}&nbsp;&nbsp;&nbsp;</span>
    <button class="small-btn" (click)="exchangeService.selectedAttributeFilter = ''">{{ "sphere.clear" | translate }}</button>
  </div>
}

<div [class.grid-container]="appService.prefersGrid" [class.pad-10]="appService.prefersGrid">
  @for (ware of wares.data; track ware) {
    <myp-exchange-list-item
      tabindex="0"
      (keyup.enter)="exchangeItemTapped($event, ware.id)"
      (click)="exchangeItemTapped($event, ware.id)"
      [class.prod-item]="!appService.prefersGrid"
      [class.item-tile]="appService.prefersGrid"
      [grid]="appService.prefersGrid"
      (updateFavorites)="listUpdateFavorites($event)"
      [item]="ware"
    ></myp-exchange-list-item>
  }
</div>

<div class="pagination">
  @if (paging) {
    <div class="m-y-10">
      <fa-icon icon="spinner" [animation]="'spin'"></fa-icon>
    </div>
  }
  <div #pagingContainer [style.opacity]="paging ? 0 : 1" class="w-full">
    <span class="w-full text-center d-block t-12 m-y-10">{{ "sphere.showing" | translate }} {{ wares.data.length }} / {{ wares.total }}</span>
    @if (wares.total > wares.data.length) {
      <span class="show-more" (click)="nextPage()">
        <fa-icon icon="caret-down"></fa-icon>
        &nbsp;&nbsp;&nbsp;{{ "sphere.workspaces.show_more" | translate }}&nbsp;&nbsp;&nbsp;
        <fa-icon icon="caret-down"></fa-icon>
      </span>
    }
  </div>
</div>
